(function (app) {
	app.module('qbePortal', ['ui.date', 'ui.bootstrap', 'credit-cards', 'ui.select', 'ngSanitize', 'ipCookie', 'ui.mask', 'ngDialog', 'ActivityMonitor', 'vcRecaptcha']);
	app.module('qbePortal.services', []);

	/** These need to be replaced with existing routes
	 *  when the right ng-app value is updated on the backend templates for qbePortal.routes.vehicle
	 */

	app.module('qbePortal.services.vehicle', ['qbePortal.services']);
	app.module('qbePortal.services.bike', ['qbePortal.services']);
	app.module('qbePortal.services.caravan', ['qbePortal.services']);
	app.module('qbePortal.services.home', ['qbePortal.services']);
	app.module('qbePortal.services.ctp', ['qbePortal.services']);
	app.module('qbePortal.services.payments', ['qbePortal.services']);

	app.module('qbePortal.routes', ['ui.router', 'qbePortal', 'angular-jwt', 'angulartics', 'angulartics.google.analytics']);
	app.module('qbePortal.routes.vehicle', ['qbePortal.routes', 'qbePortal.services.vehicle']);
	app.module('qbePortal.routes.bike', ['qbePortal.routes', 'qbePortal.services.bike']);
	app.module('qbePortal.routes.caravan', ['qbePortal.routes', 'qbePortal.services.caravan', 'rzModule']);
	app.module('qbePortal.routes.home', ['qbePortal.routes', 'qbePortal.services.home', 'rzModule']);
	app.module('qbePortal.routes.ctp', ['qbePortal.routes', 'qbePortal.services.ctp']);
	app.module('qbePortal.routes.payments', ['qbePortal.routes', 'qbePortal.services.payments']);

	app.module('qbePortal.rapidEstimate.vehicle', ['ui.router', 'qbePortal', 'qbePortal.services.vehicle', 'rzModule']);
	app.module('qbePortal.rapidEstimate.bike', ['ui.router', 'qbePortal', 'qbePortal.services.bike', 'rzModule']);
	app.module('qbePortal.rapidEstimate.caravan', ['ui.router', 'qbePortal', 'qbePortal.services.caravan', 'rzModule']);

})(angular);
